// Image resize utility function
const resizeImage = (file, maxSizeKB = 50) => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      const maxWidth = 400;
      const maxHeight = 300;
      let { width, height } = img;

      if (width > height) {
        if (width > maxWidth) {
          height = (height * maxWidth) / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width = (width * maxHeight) / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      let quality = 0.9;
      let dataURL = canvas.toDataURL('image/jpeg', quality);

      const getBase64Size = (base64String) => {
        const stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
        return Math.round(stringLength * 0.75);
      };

      while (getBase64Size(dataURL) > maxSizeKB * 1024 && quality > 0.1) {
        quality -= 0.1;
        dataURL = canvas.toDataURL('image/jpeg', quality);
      }

      resolve(dataURL);
    };

    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
};

// Enhanced URL validation helper
const isValidImageUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  
  try {
    new URL(url);
  } catch {
    return false;
  }

  const imageExtRegex = /\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)(\?.*)?$/i;
  const imageHostRegex = /(imgur|cloudinary|unsplash|pexels|pixabay|flickr|googleusercontent|amazonaws|cloudfront)/i;
  
  return imageExtRegex.test(url) || imageHostRegex.test(url);
};

// Convert admin's local "YYYY-MM-DDTHH:mm" to ISO UTC string
const toIsoFromLocal = (localStr) => {
  if (!localStr) return '';
  
  const [datePart, timePart] = localStr.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const [hh, mm] = (timePart || '00:00').split(':').map(Number);
  
  const localDate = new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0, 0, 0);
  return localDate.toISOString();
};


export { resizeImage, isValidImageUrl, toIsoFromLocal };
